<div class="anonymous-language-menu-item-container">
    <div *ngFor="let item of schema" (click)="setLocale(item.locale)">
        <span>{{item.locale.language | l10nDisplayNames:locale.language:{ type: 'language' } }}</span>
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-check icon phr-iconset" *ngIf="item.locale.language == locale.language"></mat-icon>
    </div>
</div>